var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopyRegular(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1160,
    height: 1326,
    viewBox: "0 0 1160 1326",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M994.286 870.188H497.143C474.357 870.188 455.714 851.541 455.714 828.75V165.75C455.714 142.959 474.357 124.312 497.143 124.312H859.902L1035.71 300.163V828.75C1035.71 851.541 1017.07 870.188 994.286 870.188ZM497.143 994.5H994.286C1085.69 994.5 1160 920.171 1160 828.75V300.163C1160 267.272 1146.79 235.676 1123.49 212.367L947.937 36.5168C924.634 13.2082 893.045 0 860.161 0H497.143C405.741 0 331.429 74.3285 331.429 165.75V828.75C331.429 920.171 405.741 994.5 497.143 994.5ZM165.714 331.5C74.3125 331.5 0 405.829 0 497.25V1160.25C0 1251.67 74.3125 1326 165.714 1326H662.857C754.259 1326 828.571 1251.67 828.571 1160.25V1077.38H704.286V1160.25C704.286 1183.04 685.643 1201.69 662.857 1201.69H165.714C142.929 1201.69 124.286 1183.04 124.286 1160.25V497.25C124.286 474.459 142.929 455.812 165.714 455.812H248.571V331.5H165.714Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyRegular);
export default __webpack_public_path__ + "static/media/copy-regular.10c1e38d64e250886b5f1510381ada5d.svg";
export { ForwardRef as ReactComponent };